export default __webpack_public_path__ + "static/media/placeholder_dummy2016-allgemeinarzt01-mobile-de.d06c4e1e.png";